/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
import * as alertModules from './alert'
import * as httpModules from './http'
import * as storageModules from './storage'
import requestCache, { getRequestHash, getEtagHeaderName } from './http/requestCache'

export const alert = alertModules
export const http = { ...httpModules, getEtagHeaderName, getRequestHash, requestCache }
export const storage = storageModules

export applyIsLoading from './applyIsLoading'
export downloadResponseAsync from './downloadResponseAsync'
export Validation from './Validation'
export jestMock from './jestMock'
export FormDataSerializer from './FormDataSerializer'
export { ensureIsMutable } from './helpers'
